function MacroStreamModalController(stateService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.variables = ctrl.resolve.variables;
  };

  ctrl.checkMacro = () => {
    let VAR = ctrl.macroStream.name.substring(
      ctrl.macroStream.name.indexOf("$") + 1, 
      ctrl.macroStream.name.lastIndexOf("$")
    );
    if (ctrl.variables.macro_variables.includes(VAR)) {
      ctrl.invalidMacro = false;
    } else {
      ctrl.invalidMacro = true;
    }
  };

  ctrl.submit = () => {
    ctrl.close({ $value: ctrl.macroStream });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('MacroStreamModalController', MacroStreamModalController);
